import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"api-aggregate\"><g id=\"Vector\"><path d=\"M9 1.6875C7.13604 1.6875 5.625 3.19854 5.625 5.0625C5.625 6.92646 7.13604 8.4375 9 8.4375C10.864 8.4375 12.375 6.92646 12.375 5.0625C12.375 3.19854 10.864 1.6875 9 1.6875Z\" fill=\"currentColor\"></path><path d=\"M4.875 8.8125C3.01104 8.8125 1.5 10.3235 1.5 12.1875C1.5 14.0515 3.01104 15.5625 4.875 15.5625C6.73896 15.5625 8.25 14.0515 8.25 12.1875C8.25 10.3235 6.73896 8.8125 4.875 8.8125Z\" fill=\"currentColor\"></path><path d=\"M13.125 8.8125C11.261 8.8125 9.75 10.3235 9.75 12.1875C9.75 14.0515 11.261 15.5625 13.125 15.5625C14.989 15.5625 16.5 14.0515 16.5 12.1875C16.5 10.3235 14.989 8.8125 13.125 8.8125Z\" fill=\"currentColor\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }